import { useSeo } from "@/lib/seo";
import { Reveal } from "@/components/Reveal";
import { PageHeader, Note } from "@/components/Bits";

const Discover = () => {
  useSeo({
    title: "Discover",
    description: "Search participating MONOE businesses, browse by category, and filter by the features you care about.",
    path: "/discover",
  });

  return (
    <div>
      <PageHeader eyebrow="Discover" title="Discover local businesses on MONOE." testId="discover-hero" />
      <section>
        <div className="mx-auto max-w-3xl px-4 py-16 sm:px-6 lg:px-8 lg:py-24">
          <Reveal>
            <p className="text-lg leading-relaxed text-muted-foreground">
              Search participating MONOE businesses, browse by category, and filter by the features
              you care about — pickup, dine-in, waitlist, or reservations. See which businesses offer
              rewards, and hide the ones that aren't for you. MONOE shows businesses on the platform
              first; you can also choose to search the web for places that haven't joined yet.
            </p>
          </Reveal>
          <Reveal delay={0.05}>
            <Note testId="discover-note">
              Discover surfaces participating MONOE businesses — it is not a directory of every
              business, and it does not require sharing your precise location.
            </Note>
          </Reveal>
        </div>
      </section>
    </div>
  );
};

export default Discover;
